import Button from "@/common/elements/Button";
import {
  InmateDetailsTableContainer,
  TableHeader,
} from "@/components/InmateDetails/styles";
import { useEffect, useRef, useState } from "react";
import EquipmentsModal from "./EquipmentsModal";
import DataTable from "@/common/elements/DataTable";
import { StyledFlex } from "@/common/styles";
import { useDispatch, useSelector } from "react-redux";
import { getRefListNameByID, isNonEmptyVariable } from "@/util/common_function";
import dayjs from "dayjs";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import API_ENDPOINTS from "@/util/api";
import Popconfirm from "@/common/elements/Popconfirm";
import _ from "lodash";
import { v4 as uuidV4 } from "uuid";

const EquipmentsHeader = [
  { key: "id", text: "ID" },
  { key: "productName", text: "Product" },
  { key: "dateAssigned", text: "Date Assigned" },
  { key: "statusName", text: "Status" },
  { key: "dateReturned", text: "Date Returned" },
];

const Equipments = () => { 
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector((s) => s?.bookings);
  const [isModalShown, setIsModalShown] = useState(false);
  const [staffProperty, setStaffProperty] = useState([]);
  const [selectStaffProperty, setSelectStaffProperty] = useState(null);
  const datatableRef = useRef();

  useEffect(() => {
    if (isNonEmptyVariable(bookings)) {
      const sp = bookings?.staffProperty?.map((s, index) => {
        return {
          ...s,
          id: index + 1,
          uuid: uuidV4(),
          productName: isNonEmptyVariable(s?.productID)
            ? getRefListNameByID("StaffProperty_Product", s?.productID)
            : "",
          statusName: isNonEmptyVariable(s?.statusID)
            ? getRefListNameByID("StaffProperty_Status", s?.statusID)
            : "",
        };
      });

      setStaffProperty(() => sp || []);
    } else {
      setStaffProperty(() => []);
    }
  }, [bookings]);

  const onRowClick = (value, index) => {
    if (isNonEmptyVariable(value)) {
      const data = {
        ...value,
        dateAssigned: isNonEmptyVariable(value?.dateAssigned)
          ? dayjs(value?.dateAssigned)
          : null,
        dateReturned: isNonEmptyVariable(value?.dateReturned)
          ? dayjs(value?.dateReturned)
          : null,
      };
      setSelectStaffProperty(() => data);
      if(index !== null && index !== undefined) {
        onEditClick();
      }
    }
  };

  const onAddClick = () => {
    setSelectStaffProperty(() => null);
    setIsModalShown(true);
  };

  const onEditClick = () => {
    setIsModalShown(true);
  };

  const handleSubmit = (values) => {
    let staffPropertyData = _.cloneDeep(staffProperty);
    if (isNonEmptyVariable(selectStaffProperty)) {
      staffPropertyData = staffPropertyData?.map((m) => {
        if (m?.uuid === selectStaffProperty?.uuid) {
          return {
            ...m,
            ...values,
          };
        }

        return m;
      });
    } else {
      staffPropertyData?.push(values);
    }

    setStaffProperty(() => staffPropertyData);
    dispatch(
      setBookings({
        staffProperty: staffPropertyData,
      })
    );
    handleCancel();
  };

  const handleCancel = () => {
    setSelectStaffProperty(() => null);
    setIsModalShown(false);
    datatableRef?.current?.resetAll();
  };

  const handleDelete = () => {
    let staffPropertyData = _.cloneDeep(staffProperty);
    if (isNonEmptyVariable(selectStaffProperty)) {
      staffPropertyData = staffPropertyData?.filter(
        (m) => m?.uuid !== selectStaffProperty?.uuid
      );

      if (isNonEmptyVariable(selectStaffProperty?.staffPropertyID)) {
        const url =
          API_ENDPOINTS.staff.staffProperty.delete +
          selectStaffProperty?.staffPropertyID;
        dispatch(setDeleteAPis(url));
      }
    }

    setStaffProperty(() => staffPropertyData);
    dispatch(
      setBookings({
        staffProperty: staffPropertyData,
      })
    );

    handleCancel();
  };

  return (
    <>
      <InmateDetailsTableContainer>
        <TableHeader>
          <h6>Assigned Equipment</h6>
          <StyledFlex gap="10px">
            <Button
              color="primary"
              type="primary"
              className="add-btn"
              onClick={onAddClick}
              disabled={!bookingsFieldsEnabled}
            >
              Add
            </Button>
            <Button
              color="primary"
              type="primary"
              onClick={onEditClick}
              disabled={selectStaffProperty === null}
            >
              Details
            </Button>
            <Popconfirm
              title="Delete the assigned equipment"
              description="Are you sure to delete this assigned equipment?"
              onConfirm={handleDelete}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                disabled={
                  selectStaffProperty === null || !bookingsFieldsEnabled
                }
              >
                Delete
              </Button>
            </Popconfirm>
            <Button
              color="primary"
              type="primary"
              disabled={selectStaffProperty === null}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </StyledFlex>
        </TableHeader>
        <DataTable
          ref={datatableRef}
          rowUniqueId="uuid"
          headers={EquipmentsHeader}
          data={staffProperty || []}
          onRowClick={onRowClick}
          selected={selectStaffProperty === null}
          allowTableSorting={true}
        />
      </InmateDetailsTableContainer>
      <EquipmentsModal 
        show={isModalShown}
        formSubmit={handleSubmit}
        handleCancel={handleCancel}
        selectStaffProperty={selectStaffProperty}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
      />
    </>
  );
};

export default Equipments;
